import React, { useEffect, useState } from 'react'
import "./LoadingScreen.css";

const LoadingScreen = ({ finishedState }) => {

    const [finished, setFinished] = useState(false);

    useEffect(() => {
        setFinished(finishedState);
    }, [finishedState]);

    const removeLoadingScreen = (event) => {
        if (event.target === event.currentTarget) {
            event.currentTarget.remove();
        }
    }

    return (
        <div className={`loading-screen ${ finished ? "disappear" : ""}`} onAnimationEnd={removeLoadingScreen}>
            <img src={require("../Images/loader/pikachu-loader.gif")} alt="pikachu loader image" className="pikachu-loader"/>
            <h1 className="title">Loading</h1> 
        </div>
    )
}

export default LoadingScreen
